<template>
  <div class="rank-container">
    <el-card class="rank-card" shadow="hover">
      <div slot="header" class="clearfix">
        <span>排行榜</span>
      </div>
      <div class="rank-tabs">
        <el-tabs v-model="activeTab">
          <el-tab-pane label="积分排行" name="score"></el-tab-pane>
          <el-tab-pane label="胜率排行" name="winRate"></el-tab-pane>
          <el-tab-pane label="场次排行" name="matches"></el-tab-pane>
          <el-tab-pane label="英雄使用排行" name="hero"></el-tab-pane>
          <el-tab-pane label="MVP排行" name="mvp"></el-tab-pane>
        </el-tabs>
      </div>
      <div class="rank-content">
        <h3>排行榜功能开发中...</h3>
        <p>敬请期待！</p>
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'Rank',
  data() {
    return {
      activeTab: 'score'
    }
  }
}
</script>

<style scoped>
.rank-container {
  padding: 20px 0;
}

.rank-card {
  margin-bottom: 20px;
}

.rank-tabs {
  margin-bottom: 20px;
}

.rank-content {
  text-align: center;
  padding: 50px 0;
}
</style>